import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { DROP_PATH } from '@/lib/tube-geometry'

interface SoftlyLogoProps {
    className?: string
    markClassName?: string
    wordClassName?: string
}

// Drop mark plus the handwritten wordmark.
const SoftlyLogo: FC<SoftlyLogoProps> = ({ className, markClassName, wordClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2 text-cocoa', className)}>
            <svg viewBox='0 0 20 26' className={cn('h-[22px] w-auto shrink-0', markClassName)} aria-hidden='true' focusable='false'>
                <path d={DROP_PATH} fill='currentColor' />
                <path d='M6.4 15.6C6.4 18.3 8.1 20.4 10.5 20.9' fill='none' strokeWidth='1.5' strokeLinecap='round' className='stroke-cream/80' />
            </svg>

            <span className={cn('translate-y-px font-heading text-[2rem] leading-none tracking-[0.02em]', wordClassName)}>
                Softly
            </span>
        </span>
    )
}

export default SoftlyLogo
